var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_158",
    "data-name": "Gruppe 158",
    transform: "translate(-0.293 -0.112)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(0.293 0.112)",
    fill: "#627eea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_157",
    "data-name": "Gruppe 157",
    transform: "translate(11.069 4.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_798",
    "data-name": "Pfad 798",
    d: "M16.5,4V14.833l9.156,4.091Z",
    transform: "translate(-7.341 -4)",
    fill: "rgba(255,255,255,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_799",
    "data-name": "Pfad 799",
    d: "M18.157,4,9,18.924l9.157-4.091Z",
    transform: "translate(-9 -4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_800",
    "data-name": "Pfad 800",
    d: "M16.5,22.931v7.361L25.66,17.616Z",
    transform: "translate(-7.341 -0.987)",
    fill: "rgba(255,255,255,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_801",
    "data-name": "Pfad 801",
    d: "M18.157,30.292V22.93L9,17.616Z",
    transform: "translate(-9 -0.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_802",
    "data-name": "Pfad 802",
    d: "M16.5,22.277l9.156-5.316L16.5,12.872Z",
    transform: "translate(-7.341 -2.036)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_803",
    "data-name": "Pfad 803",
    d: "M9,16.961l9.157,5.316V12.872Z",
    transform: "translate(-9 -2.036)",
    fill: "rgba(255,255,255,0.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthToken);
export default __webpack_public_path__ + "static/media/ETH-Token.9f1012a84fb00bbbdac5895c751c5aca.svg";
export { ForwardRef as ReactComponent };